<template>
  <div
    class="recommend-fulfillment-bulk-order-modal__cover"
    @click.self="onClickModalCover"
  >
    <div class="recommend-fulfillment-bulk-order-modal__content">
      <div class="recommend-fulfillment-bulk-order-modal__header">
        <CloseCircleOutline
          class="recommend-fulfillment-bulk-order-modal__close-icon"
          @click="onClickCloseButton"
        />
        <span>まとめてオーダー for 手渡しギフトとは？</span>
      </div>
      <div class="recommend-fulfillment-bulk-order-modal__body">
        <div class="recommend-fulfillment-bulk-order-modal__title-area">
          <ImgLazy
            :image-url="BulkOrderCardSuggest"
            aspect-ratio="69 / 73"
            class="recommend-fulfillment-bulk-order-modal__title-image"
          />
          <p class="recommend-fulfillment-bulk-order-modal__heading">
            <span>まとめてオーダーは、</span>
            <span>複数のギフトカードをまとめて購入できる</span>
            <span>サービスです。</span>
          </p>
        </div>
        <div>
          <p class="recommend-fulfillment-bulk-order-modal__main-text">
            <span
              >複数人に手渡しで配りたいとき、通常はご自身でURLをQRコード化し、台紙に印刷する必要があります。</span
            >
            <span class="recommend-fulfillment-bulk-order-modal__bold"
              >「まとめてオーダー for 手渡しギフト」</span
            >
            <span>なら、</span>
            <span class="recommend-fulfillment-bulk-order-modal__bold"
              >複数のギフトカードを一度にまとめて購入でき、QRコード印字したカードを配送で納品</span
            >
            <span>いたします。</span>
          </p>
        </div>
        <div
          class="recommend-fulfillment-bulk-order-modal__sample-card-image-area"
        >
          <ImgLazy
            :image-url="SampleCard"
            aspect-ratio="193 / 130"
            class="recommend-fulfillment-bulk-order-modal__sample-card-image"
          />
          <p class="recommend-fulfillment-bulk-order-modal__sub-text">
            カード形式イメージ（サイズ：w85.6 × h54 mm）
          </p>
        </div>
        <BoxListAttention>
          <p class="recommend-fulfillment-bulk-order-modal__caption-primary">
            ご利用の際は以下にご注意ください。
          </p>
          <ul class="recommend-fulfillment-bulk-order-modal__list">
            <li>
              ギフトカードの合計が<strong
                class="recommend-fulfillment-bulk-order-modal__bold"
                >11件以上</strong
              >からお申し込み受付。
            </li>
            <li>
              お支払い方法は<strong
                class="recommend-fulfillment-bulk-order-modal__bold"
                >銀行振り込み</strong
              >のみ。
            </li>
            <li>
              <strong class="recommend-fulfillment-bulk-order-modal__bold"
                >個人名義の口座</strong
              >からのお振り込みのみ可能。
            </li>
            <li>
              <strong class="recommend-fulfillment-bulk-order-modal__bold"
                >QRコードを印字したギフトカードを作成</strong
              >し、<strong class="recommend-fulfillment-bulk-order-modal__bold"
                >配送</strong
              >にて納品。
            </li>
            <li>
              ご入金確認後<strong
                class="recommend-fulfillment-bulk-order-modal__bold"
                >原則14日以内</strong
              >に発送。
            </li>
            <li>カード発行手数料：1枚につき200円（税込）</li>
            <li>配送料：全国一律 840円（税込）</li>
          </ul>
        </BoxListAttention>
        <div class="recommend-fulfillment-bulk-order-modal__btn--link">
          <a href="/announcements/698" @click="onClickBulkPhysLp"
            >詳しい情報はこちら</a
          >
        </div>
      </div>
      <div class="recommend-fulfillment-bulk-order-modal__footer">
        <div class="recommend-fulfillment-bulk-order-modal__btn-area">
          <ButtonPrimary
            text="まとめてオーダーを利用する"
            @click-primary-button="onClickBulkOrder"
          />
          <p class="recommend-fulfillment-bulk-order-modal__sub-text">
            <span>現在選択中のギフトがある場合、内容は引き継がれず、</span>
            <span
              >新たにまとめてオーダー for
              手渡しギフトの申し込み画面へ移動します。</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CloseCircleOutline from '../../atoms/svg_icons/CloseCircleOutline.vue'
import BulkOrderCardSuggest from '../../../../../images/personal-bulk-order-card-suggest.png'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'
import BoxListAttention from '../../molecules/box_list/BoxListAttention.vue'
import SampleCard from '../../../../../images/personal-bulk-order-sample-card.png'
import ImgLazy from '../../atoms/images/ImgLazy.vue'
import { BULK_ORDER_TEWATASHI_FORM_URL } from '../../../constants/externalLinkConstants'

const emit = defineEmits(['clicked-modal-cover', 'clicked-close'])

const onClickModalCover = () => {
  emit('clicked-modal-cover')
}

const onClickCloseButton = () => {
  emit('clicked-close')
}

const onClickBulkPhysLp = () => {
  dataLayer.push({
    event: 'click_bulk_detail_modal__bulk_phys_lp',
    via: 'item_detail'
  })
}

const onClickBulkOrder = () => {
  dataLayer.push({
    event: 'click_bulk_detail_modal__formrun',
    via: 'item_detail'
  })
  window.location.href = BULK_ORDER_TEWATASHI_FORM_URL
}
</script>

<style lang="scss" scoped>
.recommend-fulfillment-bulk-order-modal {
  &__cover {
    // header が 100 なので 101 をセットする
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 92%;
    padding: 0 4%;
    background-color: $dark_black_cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  &__content {
    background: $white;
    border-radius: 8px;
    text-align: center;
    width: 100%;
    max-width: 343px;
    max-height: 90%;
    margin: auto 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    // 横幅が375px以下の場合、モーダル横の余白を確保するために横幅を300pxにする
    @media screen and (max-width: $small-contents-width) {
      width: 300px;
    }
  }

  &__header {
    @extend %body-bold;
    padding: 24px 24px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: solid $gray-1 1px;

    @media screen and (max-width: $small-contents-width) {
      padding-left: 4.3%;
      padding-right: 4.3%;
    }
  }

  &__body {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    // 65px: headerの高さ, 124px: footerの高さ
    max-height: calc(100% - 65px - 124px);
  }

  &__footer {
    padding: 16px 24px 24px;
    border-top: solid $gray-2 1px;
  }

  &__title-area,
  &__sample-card-image-area,
  &__btn-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }

  &__title-area {
    gap: 8px;
  }

  &__sample-card-image-area {
    gap: 4px;
    width: 100%;
    padding: 8px;
    background-color: $gray-3;
    border-radius: 4px;
  }

  &__btn-area {
    gap: 8px;
    width: 100%;
  }

  &__heading {
    @extend %body-bold;
    color: $black;
    text-align: center;

    span {
      display: block;
    }
  }

  &__caption-primary {
    @extend %caption-bold;
    color: $primary;
    text-align: left;
    margin-bottom: 4px;
  }

  &__main-text {
    @extend %caption;
    display: flex;
    flex-wrap: wrap;
    color: $black;
    text-align: left;
  }

  &__title-image {
    width: 69px;
    object-fit: contain;
  }

  &__sample-card-image {
    width: 240px;
    max-width: 100%;
    object-fit: contain;
  }

  &__sub-text {
    @extend %minimal;
    color: $gray-1;
    text-align: center;

    span {
      display: block;
    }
  }

  &__list {
    @extend %caption-black;
    padding-left: 16px;

    li {
      list-style: outside;
    }
  }

  &__btn {
    &--link {
      font-size: 1.2rem;
      line-height: 1.6;

      a {
        color: $link;
        margin: auto;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  &__bold {
    font-weight: bold;
  }
}
</style>
